if (!customElements.get('superstore-countdown-timer')) {
  customElements.define('superstore-countdown-timer', class SuperstoreCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.dateStart = new Date(this.dataset.start).getTime();
      this.dateEnd = new Date(this.dataset.end).getTime();
      if (!isNaN(this.dateStart) && !isNaN(this.dateEnd)) {
        this.initTimer();
      }
    }
    initTimer() {
      let _this = this;
      let timerInterval = setInterval(function () {
        let currentDate = new Date().getTime();
        let distance = _this.dateEnd - currentDate;
        let distanceStart = _this.dateStart - currentDate;
        let days    = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (_this.querySelector('[data-days]'))    _this.querySelector('[data-days]').innerHTML    = ((days    < 10) ? '0' : '') + days;
        if (_this.querySelector('[data-hours]'))   _this.querySelector('[data-hours]').innerHTML   = ((hours   < 10) ? '0' : '') + hours;
        if (_this.querySelector('[data-minutes]')) _this.querySelector('[data-minutes]').innerHTML = ((minutes < 10) ? '0' : '') + minutes;
        if (_this.querySelector('[data-seconds]')) _this.querySelector('[data-seconds]').innerHTML = ((seconds < 10) ? '0' : '') + seconds;
        if (distance < 0 || distanceStart > 0) {
          clearInterval(timerInterval);
          _this.remove();
        } else {
          _this.removeAttribute('style');
        }
      }, 1000);
    }
  });
}
